import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from '@modules/main/main.component';
import { BlankComponent } from '@pages/blank/blank.component';
import { LoginComponent } from '@modules/login/login.component';
import { ProfileComponent } from '@pages/profile/profile.component';
import { RegisterComponent } from '@modules/register/register.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { AuthGuard } from '@guards/auth.guard';
import { NonAuthGuard } from '@guards/non-auth.guard';
import { ForgotPasswordComponent } from '@modules/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from '@modules/recover-password/recover-password.component';
import { SubMenuComponent } from '@pages/main-menu/sub-menu/sub-menu.component';
import { WebsiteComponent } from '@pages/website/website.component';
import { DetailViewComponent } from '@pages/detail-view/detail-view.component';
import { InvoiceComponent } from "@pages/invoice/invoice.component";
import { AddNewProductComponent } from '@pages/admin/add-new-product/add-new-product.component';
import { ProductViewComponent } from '@pages/admin/product-view/product-view.component';
import { EnquiryComponent } from "@pages/enquiry/enquiry.component";
import { BillComponent } from "@pages/bill/bill.component";
import { ShopBillListTableComponent } from '@pages/admin/shop-bill-list-table/shop-bill-list-table.component';
import { BarcodePrintPageComponent } from './pages/barcode-print-page/barcode-print-page.component';
import { FreeStageEntryPageComponent } from '@pages/admin/free-stage-entry-page/free-stage-entry-page.component';
import { VariantViewComponent } from '@pages/variant-view/variant-view.component';
import { AddShippingDetailsComponent } from '@pages/add-shipping-details/add-shipping-details.component';
import { CustomerLoginPageComponent } from '@pages/customer/customer-login-page/customer-login-page.component';
import { CartPageComponent } from '@pages/customer/cart-page/cart-page.component';
import { AddCategoryComponent } from '@pages/admin/add-category/add-category.component';
import { MyOrdersComponent } from '@pages/customer/my-orders/my-orders.component';
import { OrderProcessingComponent } from '@pages/admin/order-processing/order-processing.component';
import { DispatchManagementComponent } from '@pages/admin/dispatch-management/dispatch-management.component';
import { TransactionDetailsComponent } from '@pages/admin/transaction-details/transaction-details.component';
import { UserActivityLogComponent } from '@pages/admin/user-activity-log/user-activity-log.component';
import { ReportDetailsComponent } from '@pages/admin/report-details/report-details.component';
import { LegalPolicyComponent } from '@pages/admin/policy-details/legal-policy/legal-policy.component';
import { ExpenseMasterComponent } from '@pages/admin/expense-module/expense-master/expense-master.component';
import { DailyExpenseEntryComponent } from '@pages/admin/expense-module/daily-expense-entry/daily-expense-entry.component';
import { DailyExpenseViewComponent } from '@pages/admin/expense-module/daily-expense-view/daily-expense-view.component';

const routes: Routes = [
  {
    path: 'main',
    component: MainComponent,
    canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    children: [
      {
        path: 'profile',
        component: ProfileComponent
      },
      {
        path: 'blank',
        component: BlankComponent
      },
      {
        path: 'sub-menu-1',
        component: SubMenuComponent
      },
      {
        path: 'sub-menu-2',
        component: BlankComponent
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'invoice',
        component: InvoiceComponent
      },
      {
        path: 'add-new-product',
        component: AddNewProductComponent
      },
      {
        path: 'product-view',
        component: ProductViewComponent
      },
      {
        path: 'enquiry',
        component: EnquiryComponent
      },
      {
        path: 'shop-bill-list',
        component: ShopBillListTableComponent
      },
      {
        path: 'free-stage-entry',
        component: FreeStageEntryPageComponent
      },
      {
        path: 'add-shipping-address',
        component: AddShippingDetailsComponent
      },
      {
        path: 'add-category',
        component: AddCategoryComponent
      },
      {
        path: 'barcode-print-page',
        component: BarcodePrintPageComponent
      },
      {
        path: 'order-processing',
        component: OrderProcessingComponent
      },
      {
        path: 'dispatch-management',
        component: DispatchManagementComponent
      },
      {
        path: 'transaction-details',
        component: TransactionDetailsComponent
      },
      {
        path: 'activity-log',
        component: UserActivityLogComponent
      },
      {
        path: 'report-details',
        component: ReportDetailsComponent
      },
      {
        path: 'expense-master',
        component: ExpenseMasterComponent
      },
      {
        path: 'daily-expense-entry',
        component: DailyExpenseEntryComponent
      },
      {
        path: 'daily-expense-view',
        component: DailyExpenseViewComponent
      },
    ]
  },
  {
    path: 'login',
    component: LoginComponent,
    // canActivate: [NonAuthGuard]
  },
  {
    path: 'register',
    component: RegisterComponent,
    // canActivate: [NonAuthGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    // canActivate: [NonAuthGuard]
  },
  {
    path: 'recover-password',
    component: RecoverPasswordComponent,
    // canActivate: [NonAuthGuard]
  },
  {
    path: '',
    component: WebsiteComponent,
    // canActivate: [NonAuthGuard]
  },
  {
    path: 'detail-view',
    component: DetailViewComponent,
  },
  {
    path: 'variant-view',
    component: VariantViewComponent,
  },
  {
    path: 'bill',
    component: BillComponent
  },
  {
    path: 'customer-login',
    component: CustomerLoginPageComponent
  },
  {
    path: 'cart',
    component: CartPageComponent
  },
  {
    path: 'my-orders',
    component: MyOrdersComponent
  },
  {
    path: 'terms-and-conditions',
    component: LegalPolicyComponent,
    data: { title: 'Terms and Conditions | Budget Bazaar' }
  },
  {
    path: 'privacy-policy',
    component: LegalPolicyComponent,
    data: { title: 'Privacy Policy | Budget Bazaar' }
  },
  {
    path: 'refund-policy',
    component: LegalPolicyComponent,
    data: { title: 'Refund Policy | Budget Bazaar' }
  },
  {
    path: 'cancellation-policy',
    component: LegalPolicyComponent,
    data: { title: 'Cancellation Policy | Budget Bazaar' }
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
